import React from 'react';




interface Industry {
  id: string;
  name: string;
  icon: string;
  description: string;
  image: string;
  alt: string;
  stats: {
    label: string;
    value: string;
  }[];
  href: string;
}

interface IndustryPortalsProps {
  className?: string;
}

const IndustryPortals: React.FC<IndustryPortalsProps> = ({ className = '' }) => {
  const industries: Industry[] = [
  {
    id: 'telecom',
    name: 'Telecommunications',
    icon: 'SignalIcon',
    description: 'Transform network operations and customer service with AI-powered automation and predictive analytics.',
    image: "https://images.unsplash.com/photo-1726329960121-6c9a6398750a",
    alt: 'Modern telecommunications tower with 5G equipment against blue sky with white clouds',
    stats: [
    { label: 'Network Uptime', value: '99.9%' },
    { label: 'Cost Reduction', value: '45%' }],

    href: '/industry-solutions#telecom'
  },
  {
    id: 'banking',
    name: 'Banking & Finance',
    icon: 'BuildingLibraryIcon',
    description: 'Deliver secure, compliant, and personalized banking experiences across all customer touchpoints.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_187c76ca2-1766506240891.png",
    alt: 'Modern banking hall with marble columns and digital screens showing financial data',
    stats: [
    { label: 'Fraud Detection', value: '98%' },
    { label: 'Customer Trust', value: '92%' }],

    href: '/industry-solutions#banking'
  },
  {
    id: 'retail',
    name: 'Retail & E-commerce',
    icon: 'ShoppingBagIcon',
    description: 'Create seamless omnichannel experiences that drive engagement, loyalty, and revenue growth.',
    image: "https://images.unsplash.com/photo-1733503747506-773e56e4078f",
    alt: 'Person shopping online on laptop with shopping bags and credit card on wooden desk',
    stats: [
    { label: 'Conversion Rate', value: '+67%' },
    { label: 'Cart Recovery', value: '78%' }],

    href: '/industry-solutions#retail'
  }];


  return null;
};

export default IndustryPortals;